import messages from './AuthorizeUser.json'
import AppNavbar from '@/components/Dashboard/Layout/AppNavbar/AppNavbar.vue'
import AppFooter from '@/components/Dashboard/Layout/AppFooter/AppFooter.vue'
import moment from 'moment';

export default {
  name: 'AuthorizeUser',
  i18n: messages,

  components: {
    AppNavbar,
    AppFooter,
  },

  data() {
    return {
      data: [],
    }
  },

  mounted() {
    this.findUsers()
  },

  methods: {
    sortData() {
      // sort data by no date and date
      this.data.sort((a, b) => {
        if (!a.tokenRegister && !b.tokenRegister) {
          return -1
        } else if (!a.tokenRegister) {
          return -1
        } else if (!b.tokenRegister) {
          return 1
        } else {
          return a.tokenRegister < b.tokenRegister
        }
      })
    },
    /**
     * Find users not register
     */
    findUsers() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios
        .get('rest/bd/authorize/get/user/all')
        .then(response => {
          this.data = response.data
          this.sortData()
        })
        .catch(error => {
          this.failedRequest()
        })
        .finally(() => { this.$eventHub.$emit(this.$eventHub.LOADING.END) })
    },
    /**
     * Authorize/Unauthorize user
     * @param id
     * @param authorize
     */
    authorize(id, authorize) {
      const user = this.data.find(user => user.id === id)
      const request = {
        user: user,
        authorize: authorize,
      }
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios
        .post('rest/bd/authorize/user', request)
        .then(response => {
          if (response.data && response.data.supprime) {
            this.data = this.data.filter(user => user.id !== response.data.user.id)
          } else if (response.data && !response.data.supprime) {
            this.data = this.data.filter(user => user.id !== response.data.user.id)
            this.data.push(response.data.user)
            this.sortData()
          }
        })
        .catch(error => {
          this.failedRequest()
        })
        .finally(() => { this.$eventHub.$emit(this.$eventHub.LOADING.END) })
    },
    /**
     * Notification
     */
    failedRequest() {
      this.$notify({
        title: this.$t('notifications.echecRecuperationDonnees.title'),
        message: this.$t('notifications.echecRecuperationDonnees.message'),
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'error',
        timeout: 5000,
        closeOnClick: true
      })
    },
    /**
     * Expire or not
     * @param date
     * @returns {boolean}
     * @private
     */
    _isExpired(date) {
      return moment(date).isBefore(moment())
    },
    /**
     * Style for expired date
     * @param registerDate
     * @returns {string}
     * @private
     */
    _getStyle(registerDate) {
      if (this._isExpired(registerDate)) {
        return 'text-danger'
      }
      return 'text-success'
    }
  }

}
